// src/redux/store.ts
import { configureStore } from "@reduxjs/toolkit";
import { exporterApi } from "@/redux/ExportPage/CreateNewJob/General/GeneralPageapiSlice";
import { organizationApi } from "@/redux/Login/Login";
import { forgotpasswordApi } from "@/redux/ForgotPassword/ForgotPasseord";
import { emailOtpApi } from "@/redux/ForgotPassword/EmailOtp";
import { resendOtpApi } from "@/redux/ForgotPassword/ResendOtp";
import { setNewPasswordApi } from "@/redux/ForgotPassword/SetNewPassword";
import { dashboardApi } from "@/redux/ExportPage/Dashboard/DashboardSlice";
import { dashboardfilterApi } from "@/redux/ExportPage/Dashboard/DashboardfilterSlice";
import { sezinfoApi } from "@/redux/ExportPage/CreateNewJob/Sez/SezInfoSlice";
import { exportIdApi } from "@/redux/ExportPage/Dashboard/ExportIdSlice";
import { entityApi } from "@/redux/ExportPage/CreateNewJob/Entity/EntitySlice";
// import { historyApi } from "@/redux/ExportPage/CreateNewJob/History/HistorySlice";
import { udfApi } from "@/redux/ExportPage/CreateNewJob/UDF/UDFSlice";
// import { notesApi } from "./ExportPage/CreateNewJob/Notes/NoteSlice";
import { containerPackageApi } from "@/redux/ExportPage/CreateNewJob/Container/ContainerPackageSlice";
import { invoicemainApi } from "@/redux/ExportPage/CreateNewJob/Invoice/InvoiceMainSlice";
import { invoicefreightApi } from "@/redux/ExportPage/CreateNewJob/Invoice/InvoicefreightSlice";
import { invoicebuyerApi } from "@/redux/ExportPage/CreateNewJob/Invoice/InvoiceBuyerSlice";
import { invoiceotherinfoApi } from "@/redux/ExportPage/CreateNewJob/Invoice/InvoiceOtherInfoSlice";
import { shipmentinvoiceApi } from "@/redux/ExportPage/CreateNewJob/Shipment/ShipmentInvoicePrintSlice";
// import { ShipmentbillAPI } from "@/redux/ExportPage/CreateNewJob/Shipment/ShipmentBillprintSlice";
import { eSanchitApi } from "@/redux/ExportPage/CreateNewJob/eSanchit/eSanchitSlice";
import { ShipmentStuffingAPI } from "@/redux/ExportPage/CreateNewJob/Shipment/ShipmentStuffinglSlice";
import { shipmentEXbondApi } from "./ExportPage/CreateNewJob/Shipment/ShipmentEXbondSlice";
import { productmainApi } from "./ExportPage/CreateNewJob/Product/Main/ProductMainSlice";
import { productGeneralApi } from "./ExportPage/CreateNewJob/Product/General/ProductGeneralSlice";
import { shipmentAnnexApi } from "@/redux/ExportPage/CreateNewJob/Shipment/ShipmentAnnuexSlice";
import { additionalInfoApi } from "@/redux/ExportPage/CreateNewJob/Product/SingleWindow/AdditonalInfoSlice";
import { constituentsApi } from "@/redux/ExportPage/CreateNewJob/Product/SingleWindow/ConstituentSlice";
import { productDrawbackApi } from "@/redux/ExportPage/CreateNewJob/Product/DrawbackSlice";
import { productCessApi } from "@/redux/ExportPage/CreateNewJob/Product/ProductCess/CessSlice";
import { productQUotaApi } from "@/redux/ExportPage/CreateNewJob/Product/QuotaSlice";
import { productAREApi } from "@/redux/ExportPage/CreateNewJob/Product/ARESlice";
import { otherDetailsApi } from "@/redux/ExportPage/CreateNewJob/Product/Otherdetails/OtherdetailSlice";
import { drawBackApi } from "@/redux/ExportPage/CreateNewJob/Product/ProductDrawback/ProductDrawbackSlice";
import { jobWorkApi } from "@/redux/ExportPage/CreateNewJob/Product/Jobwork/JobworkSlice";
//import {productAREApi} from "@/redux/ExportPage/CreateNewJob/Product/ARESlice";
import { productaredetailsApi } from "./ExportPage/CreateNewJob/Product/Are Details/ProductAreDetails";

import { productionApi } from "@/redux/ExportPage/CreateNewJob/Product/SingleWindow/ProductionSlice";
import { controlApi } from "@/redux/ExportPage/CreateNewJob/Product/SingleWindow/ControlSlice";
import { productDucInfoApi } from "@/redux/ExportPage/CreateNewJob/Product/ProductDUC/ProductDucSlice";
import { productReExportApi } from "@/redux/ExportPage/CreateNewJob/Product/ReExport/ReExportSlice";
import { productDEPBApi } from "./ExportPage/CreateNewJob/Product/DEPB/DEPBSlice";
import { productDFRCApi } from "./ExportPage/CreateNewJob/Product/DFRC/DFRCSlice";
import { containerApi } from "@/redux/ExportPage/CreateNewJob/Container/ContainerSlice";
import { requirementApi } from "@/redux/ExportPage/CreateNewJob/Requirement/RequirementSlice"; //R
import { exchangeRateApi } from "@/redux/ExportPage/CreateNewJob/ExchangeRate/ExchangeRate";

// import {ShipmentbillAPI} from "@/redux/ExportPage/CreateNewJob/Shipment/ShipmentBillprintSlice";
//import {productAREApi} from "@/redux/ExportPage/CreateNewJob/Product/ARESlice";
import { ShipmentBillAPI } from "@/redux/ExportPage/CreateNewJob/Shipment/ShipmentbillprintSlice";
import { productDocInfoApi } from "./ExportPage/CreateNewJob/Product/ProductDocInfo/ProductDocInfoSlice";
import { mastersApi } from "@/redux/Masters/Masters";
import { exportNotesApi } from "./ExportPage/CreateNewJob/Notes/NoteSlice";
import { exporthistoryApi } from "@/redux/ExportPage/CreateNewJob/History/HistorySlice";
import SessionSlice from "./SessionSlice";
import { importerApi } from "./ImportPage/CreateNewJob/General/GeneralApiSlice";
import { importSezInfoApi } from "./ImportPage/CreateNewJob/SezInfo/SezInfoApiSlice";
import { importdashboardApi } from "@/redux/ImportPage/Dashboard/DashboardSlice";
import { importinvoicemainApi } from "@/redux/ImportPage/CreateNewJob/Invoice/InvoiceMainSlice";
import { importdashboardfilterApi } from "@/redux/ImportPage/Dashboard/DashboardfilterSlice";
import { highSeaSellerApi } from "./ImportPage/CreateNewJob/General/HighSeaSellerApiSlice";
//import shipment
import { importShipmentApi } from "./ImportPage/CreateNewJob/Shipment/ShipmentApiSlice";
import { importproductMainApi } from "./ImportPage/CreateNewJob/Product/ProductMain/MainSlice";
import { importSchemeGenericApi } from "./ImportPage/CreateNewJob/Product/General/SchemeandGenericDes/SchemeGeneric";
import { importManufacturerApi } from "./ImportPage/CreateNewJob/Product/General/Manufacuter/Manufacuter";
import { importInvoiceSvbApi } from "@/redux/ImportPage/CreateNewJob/Invoice/InvoiceRevSlice";
import { invoiceotherdetailsApi } from "@/redux/ImportPage/CreateNewJob/Invoice/InvoiceOtherInfoSlice";
import { ImportAdditionalInfoApi } from "./ImportPage/CreateNewJob/Product/SingleWindow/AdditionalInfoApi";
import { ImportConstituentsApi } from "./ImportPage/CreateNewJob/Product/SingleWindow/ConstituentsApi";
import { ImportControlApi } from "./ImportPage/CreateNewJob/Product/SingleWindow/ControlDetailsApi";
import { ImportProductionApi } from "./ImportPage/CreateNewJob/Product/SingleWindow/ProductionDetailsApi";
import { ProductFTAApi } from "./ImportPage/CreateNewJob/Product/ProductFTA/ProductFTAApiSlice";
import { invoiceSupplierApi } from "./ImportPage/CreateNewJob/Invoice/InvoiceSupplierSlice";
import { importEOUDetailsApi } from "./ImportPage/CreateNewJob/Product/LIC/EOU Details/EOUDetails";
import { importLICSchemeApi } from "./ImportPage/CreateNewJob/Product/LIC/LICSCheme/LicScheme";
import { MainShipmentApi } from "./ExportPage/CreateNewJob/Shipment/ShipmentMainSlice";
//import { importEOUDetailsItemApi } from "./ImportPage/CreateNewJob/Product/LIC/EOU Details/EOCItemSlice";
import { importentityApi } from "./ImportPage/CreateNewJob/Entity/EntitySlice";
import { esanchitApi } from "./ImportPage/CreateNewJob/Esanchit/Esanchit";
import { importProductSezinfoApi } from "./ImportPage/CreateNewJob/Product/General/Sezinfo/Sezinfo";
import { importProductLoadingApi } from "./ImportPage/CreateNewJob/Product/Loading/LoadingSlice";
import { importotherDetailsApi } from "./ImportPage/CreateNewJob/Product/Otherdetails/OtherdetailSlice";
import {importexchangeRateApi} from "./ImportPage/CreateNewJob/ExchangeRate/ExchangeRate";
import {importrequirementApi} from "./ImportPage/CreateNewJob/Requirement/RequirementSlice";
import {importudfApi} from "./ImportPage/CreateNewJob/UDF/UDFSlice";
import {importNotesApi} from "./ImportPage/CreateNewJob/Notes/NoteSlice";
import {importcontainerApi} from "./ImportPage/CreateNewJob/Shipment/ContainerSlice";
import { bondcertApi } from "./ImportPage/CreateNewJob/BondCert/BondCert";
import { reimportApi } from "./ImportPage/CreateNewJob/Product/Reimport/ReImportSilce";
import { importhistoryApi } from "./ImportPage/CreateNewJob/History/HistorySlice";
import {documentsApi} from "../redux/ExportPage/CreateNewJob/Documents";
import {organizationdashboardApi} from "../redux/Organization/Dashboard/DashboardSlice";
import {customerorganizationApi} from "../redux/Organization/CreateNewCustomer/NewCustomers";
import {organizationGeneralApi} from "../redux/Organization/CreateNewCustomer/General";
import {MoreAddressApi} from "../redux/Organization/CreateNewCustomer/MoreAddress";
import {DBKBankApi} from "../redux/ExportPage/CreateNewJob/General/DBKbank";
import { ShipmentPackageApi } from "./ExportPage/CreateNewJob/Shipment/ShipmentPacakgedetails";
import {exportDeclarationApi} from "../redux/ExportPage/CreateNewJob/Declaration";
import { shiperApi } from "./Organization/CreateNewCustomer/Shiper/ShiperSlice";
import { bankdealerApi } from "./Organization/CreateNewCustomer/CustomeDetails/BankDealer/Bankdealer";
import { KycAddressApi } from "./Organization/CreateNewCustomer/KYC/Address/KycSlice";
import { KycGeneralApi } from "./Organization/CreateNewCustomer/KYC/General/kycGeneralSlice";
import { customerNotesApi } from "./Organization/CreateNewCustomer/Notes/Notes";
import { serviceApi } from "./Organization/CreateNewCustomer/Service/Service";
import {organizationContactApi} from "../redux/Organization/CreateNewCustomer/Contact"
import {ConsigneeApi} from "./Organization/CreateNewCustomer/Consignee";
import { carrierApi } from "./Organization/CreateNewCustomer/Carrier/Carrier";
import {OrganizationhistoryApi} from "../redux/Organization/CreateNewCustomer/History/HistorySlice"
import { KycAuthorizedSlice } from "./Organization/CreateNewCustomer/KYC/AuthorizedSignatory/KycAuthorizedSlice";
import { Agentslice } from "./Organization/CreateNewCustomer/Agent/AgentSlice";
import{AEODetailsApi} from "../redux/Organization/CreateNewCustomer/CustomeDetails/BankDealer/AeoSlice";
import {KycDocumentApi} from "../redux/Organization/CreateNewCustomer/KYC/KycDocument";
import {organizationRegApi} from  "../redux/Organization/CreateNewCustomer/Reg";
import { DrawbackdetailsApi } from "./Organization/CreateNewCustomer/CustomeDetails/DrawBackDetails/Drawbackdetails";
import { CustomDetailsApi } from "./Organization/CreateNewCustomer/CustomeDetails/CustomMaster/CustomDetails";
import {organizationfilterApi} from "../redux/Organization/Dashboard/DashboardfilterSlice";
import {invoiceotherchargesApi} from "../redux/ImportPage/CreateNewJob/Invoice/InvoiceOtherCharges"
import { ActiveApi } from "./Active&InActive/ActiveSlice";
import { ProductDEECApi } from "./ExportPage/CreateNewJob/Product/DEEC/DEECSlice";
import {exportTrackingApi} from "../redux/ExportPage/CreateNewJob/Tracking/TrackingApi.jsx";
import {TrackingGoodsReciptApi} from "../redux/ExportPage/CreateNewJob/Tracking/GoodsReciptApi.jsx";
import {importProductCustDutyApi} from "../redux/ImportPage/CreateNewJob/Product/CustDuty/Custduty";
import {importProductGSTApi} from "../redux/ImportPage/CreateNewJob/Product/GST/GST";
import {importinvoicemiscApi} from "../redux/ImportPage/CreateNewJob/Invoice/InvoiceMisc";

import { exportProductEPCGApi } from "./ExportPage/CreateNewJob/Product/EPCG/EPCGSlice";
import { ProductDFIAApi } from "./ExportPage/CreateNewJob/Product/DFIA/DFIASlice";
import { invoiceDeclarationApi } from "./ImportPage/CreateNewJob/Invoice/InvoiceDeclarationSlice";
import {importProductOtherDutiesApi} from  "../redux/ImportPage/CreateNewJob/Product/OtherDuties/OtherDuties"
import { importProductDeclaration } from "./ImportPage/CreateNewJob/Product/Declaration/importProductDeclaration";
export const store = configureStore({
  reducer: {
    session: SessionSlice,
    [exporterApi.reducerPath]: exporterApi.reducer,
    [organizationApi.reducerPath]: organizationApi.reducer,
    [forgotpasswordApi.reducerPath]: forgotpasswordApi.reducer,
    [emailOtpApi.reducerPath]: emailOtpApi.reducer,
    [resendOtpApi.reducerPath]: resendOtpApi.reducer,
    [setNewPasswordApi.reducerPath]: setNewPasswordApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [sezinfoApi.reducerPath]: sezinfoApi.reducer,
    [exportIdApi.reducerPath]: exportIdApi.reducer,
    [entityApi.reducerPath]: entityApi.reducer,
    [containerApi.reducerPath]: containerApi.reducer,
    [requirementApi.reducerPath]: requirementApi.reducer,
    [exporthistoryApi.reducerPath]: exporthistoryApi.reducer,
    [udfApi.reducerPath]: udfApi.reducer,
    // [notesApi.reducerPath]: notesApi.reducer,
    [constituentsApi.reducerPath]: constituentsApi.reducer,
    [additionalInfoApi.reducerPath]: additionalInfoApi.reducer,
    [productionApi.reducerPath]: productionApi.reducer,
    [controlApi.reducerPath]: controlApi.reducer,
    [productDocInfoApi.reducerPath]: productDocInfoApi.reducer,
    [containerPackageApi.reducerPath]: containerPackageApi.reducer,
    [invoicemainApi.reducerPath]: invoicemainApi.reducer,
    [invoicefreightApi.reducerPath]: invoicefreightApi.reducer,
    [invoicebuyerApi.reducerPath]: invoicebuyerApi.reducer,
    [invoiceotherinfoApi.reducerPath]: invoiceotherinfoApi.reducer,
    [eSanchitApi.reducerPath]: eSanchitApi.reducer,
    [ShipmentStuffingAPI.reducerPath]: ShipmentStuffingAPI.reducer,
    [shipmentinvoiceApi.reducerPath]: shipmentinvoiceApi.reducer,
    [ShipmentBillAPI.reducerPath]: ShipmentBillAPI.reducer,
    // [ShipmentbillAPI.reducerPath]:ShipmentbillAPI.reducer,
    [shipmentEXbondApi.reducerPath]: shipmentEXbondApi.reducer,
    [productmainApi.reducerPath]: productmainApi.reducer,
    [productGeneralApi.reducerPath]: productGeneralApi.reducer,
    [drawBackApi.reducerPath]: drawBackApi.reducer,
    [jobWorkApi.reducerPath]: jobWorkApi.reducer,
    [shipmentAnnexApi.reducerPath]: shipmentAnnexApi.reducer,
    [productDrawbackApi.reducerPath]: productDrawbackApi.reducer,
    [productCessApi.reducerPath]: productCessApi.reducer,
    [productQUotaApi.reducerPath]: productQUotaApi.reducer,
    [productAREApi.reducerPath]: productAREApi.reducer,
    [otherDetailsApi.reducerPath]: otherDetailsApi.reducer,
    [productAREApi.reducerPath]: productAREApi.reducer,
    [productReExportApi.reducerPath]: productReExportApi.reducer,
    // [productAREApi.reducerPath]:productAREApi.reducer,
    [productaredetailsApi.reducerPath]: productaredetailsApi.reducer,
    [productDucInfoApi.reducerPath]: productDucInfoApi.reducer,
    [productDocInfoApi.reducerPath]: productDocInfoApi.reducer,
    [exportNotesApi.reducerPath]: exportNotesApi.reducer,
    [exporthistoryApi.reducerPath]: exporthistoryApi.reducer,
    [exchangeRateApi.reducerPath]: exchangeRateApi.reducer,
    [productDEPBApi.reducerPath]: productDEPBApi.reducer,
    [productDFRCApi.reducerPath]: productDFRCApi.reducer,
    [dashboardfilterApi.reducerPath]: dashboardfilterApi.reducer,
    [importerApi.reducerPath]: importerApi.reducer,
    [importSezInfoApi.reducerPath]: importSezInfoApi.reducer,
    [importdashboardApi.reducerPath]: importdashboardApi.reducer,
    [mastersApi.reducerPath]: mastersApi.reducer,
    [importinvoicemainApi.reducerPath]: importinvoicemainApi.reducer,
    [importdashboardfilterApi.reducerPath]: importdashboardfilterApi.reducer,
    [highSeaSellerApi.reducerPath]: highSeaSellerApi.reducer,
    [importShipmentApi.reducerPath]: importShipmentApi.reducer,
    [importproductMainApi.reducerPath]: importproductMainApi.reducer,
    [importSchemeGenericApi.reducerPath]: importSchemeGenericApi.reducer,
    [importInvoiceSvbApi.reducerPath]: importInvoiceSvbApi.reducer,
    [invoiceotherdetailsApi.reducerPath]: invoiceotherdetailsApi.reducer,
    [importManufacturerApi.reducerPath]: importManufacturerApi.reducer,
    [ImportAdditionalInfoApi.reducerPath]: ImportAdditionalInfoApi.reducer,
    [ImportConstituentsApi.reducerPath]: ImportConstituentsApi.reducer,
    [ImportControlApi.reducerPath]: ImportControlApi.reducer,
    [ImportProductionApi.reducerPath]: ImportProductionApi.reducer,
    [ProductFTAApi.reducerPath]: ProductFTAApi.reducer,
    [invoiceSupplierApi.reducerPath]: invoiceSupplierApi.reducer,
    [importLICSchemeApi.reducerPath]: importLICSchemeApi.reducer,
    [importEOUDetailsApi.reducerPath]: importEOUDetailsApi.reducer,
    [MainShipmentApi.reducerPath]: MainShipmentApi.reducer,
    [importotherDetailsApi.reducerPath]: importotherDetailsApi.reducer,
    [importexchangeRateApi.reducerPath]: importexchangeRateApi.reducer,
    [importrequirementApi.reducerPath]: importrequirementApi.reducer,
    [importudfApi.reducerPath]: importudfApi.reducer,
    [importNotesApi.reducerPath]: importNotesApi.reducer,
    [importentityApi.reducerPath]: importentityApi.reducer,
    [esanchitApi.reducerPath]: esanchitApi.reducer,
    [importProductSezinfoApi.reducerPath]: importProductSezinfoApi.reducer,
    [importProductLoadingApi.reducerPath] :importProductLoadingApi.reducer,
    [importcontainerApi.reducerPath] : importcontainerApi.reducer,
    [bondcertApi.reducerPath]:bondcertApi.reducer,
    [reimportApi.reducerPath]:reimportApi.reducer,
    [importhistoryApi.reducerPath]:importhistoryApi.reducer,
    [documentsApi.reducerPath]:documentsApi.reducer,
    [organizationdashboardApi.reducerPath]:organizationdashboardApi.reducer,
    [customerorganizationApi.reducerPath]:customerorganizationApi.reducer,
    [organizationGeneralApi.reducerPath]:organizationGeneralApi.reducer,
    [MoreAddressApi.reducerPath]:MoreAddressApi.reducer,
    [DBKBankApi.reducerPath]:DBKBankApi.reducer,    
    [ShipmentPackageApi.reducerPath]:ShipmentPackageApi.reducer,
    [exportDeclarationApi.reducerPath]:exportDeclarationApi.reducer,
    [shiperApi.reducerPath]:shiperApi.reducer,
    [bankdealerApi.reducerPath]:bankdealerApi.reducer,
    [KycAddressApi.reducerPath]:KycAddressApi.reducer,
    [KycGeneralApi.reducerPath]:KycGeneralApi.reducer,
    [customerNotesApi.reducerPath]:customerNotesApi.reducer,
    [serviceApi.reducerPath]:serviceApi.reducer,
    [organizationContactApi.reducerPath]:organizationContactApi.reducer,
    [ConsigneeApi.reducerPath]:ConsigneeApi.reducer,
    [carrierApi.reducerPath]:carrierApi.reducer,
    [OrganizationhistoryApi.reducerPath]:OrganizationhistoryApi.reducer,
    [AEODetailsApi.reducerPath]:AEODetailsApi.reducer,
    [KycDocumentApi.reducerPath]:KycDocumentApi.reducer,
    [organizationRegApi.reducerPath]:organizationRegApi.reducer,
    [DrawbackdetailsApi.reducerPath]:DrawbackdetailsApi.reducer,
    [CustomDetailsApi.reducerPath]:CustomDetailsApi.reducer,
    [organizationfilterApi.reducerPath]:organizationfilterApi.reducer,
    [KycAuthorizedSlice.reducerPath] : KycAuthorizedSlice.reducer,
     [Agentslice.reducerPath] : Agentslice.reducer,
     [invoiceotherchargesApi.reducerPath ]: invoiceotherchargesApi.reducer,
     [ActiveApi.reducerPath]:ActiveApi.reducer,
     [ProductDEECApi.reducerPath]:ProductDEECApi.reducer,
     [exportTrackingApi.reducerPath ]: exportTrackingApi.reducer,
     [TrackingGoodsReciptApi.reducerPath ]: TrackingGoodsReciptApi.reducer,
     [importProductCustDutyApi.reducerPath ]: importProductCustDutyApi.reducer,
     [importProductGSTApi.reducerPath ]: importProductGSTApi.reducer,
     [importinvoicemiscApi.reducerPath ]: importinvoicemiscApi.reducer,    
     [importinvoicemiscApi.reducerPath ]: importinvoicemiscApi.reducer,
     [importProductOtherDutiesApi.reducerPath ]: importProductOtherDutiesApi.reducer,
     [exportProductEPCGApi.reducerPath ]: exportProductEPCGApi.reducer,   
     [ProductDFIAApi.reducerPath ]: ProductDFIAApi.reducer, 
     [invoiceDeclarationApi.reducerPath ]: invoiceDeclarationApi.reducer,
     [importProductDeclaration.reducerPath ]: importProductDeclaration.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      exporterApi.middleware,
      organizationApi.middleware,
      forgotpasswordApi.middleware,
      emailOtpApi.middleware,
      resendOtpApi.middleware,
      setNewPasswordApi.middleware,
      dashboardApi.middleware,
      otherDetailsApi.middleware,
      sezinfoApi.middleware,
      exportIdApi.middleware,
      entityApi.middleware,
      jobWorkApi.middleware,
      containerApi.middleware,
      requirementApi.middleware,
      shipmentEXbondApi.middleware,
      udfApi.middleware,
      constituentsApi.middleware,
      additionalInfoApi.middleware,
      productionApi.middleware,
      controlApi.middleware,
      exchangeRateApi.middleware,
      containerPackageApi.middleware,
      invoicemainApi.middleware,
      invoicefreightApi.middleware,
      invoicebuyerApi.middleware,
      invoiceotherinfoApi.middleware,
      eSanchitApi.middleware,
      ShipmentStuffingAPI.middleware,
      shipmentinvoiceApi.middleware,
      // ShipmentbillAPI.middleware,
      productmainApi.middleware,
      productGeneralApi.middleware,
      shipmentAnnexApi.middleware,
      productDrawbackApi.middleware,
      ShipmentBillAPI.middleware,
      drawBackApi.middleware,
      productCessApi.middleware,
      productQUotaApi.middleware,
      productAREApi.middleware,
      productReExportApi.middleware,
      //  productAREApi.middleware
      productDEPBApi.middleware,
      productDFRCApi.middleware,
      //  productAREApi.middleware
      productaredetailsApi.middleware,
      productDucInfoApi.middleware,
      productDocInfoApi.middleware,
      exportNotesApi.middleware,
      exporthistoryApi.middleware,
      dashboardfilterApi.middleware,
      importerApi.middleware,
      importSezInfoApi.middleware,
      importdashboardApi.middleware,
      mastersApi.middleware,
      importinvoicemainApi.middleware,
      importdashboardfilterApi.middleware,
      highSeaSellerApi.middleware,
      importShipmentApi.middleware,
      importproductMainApi.middleware,
      importSchemeGenericApi.middleware,
      importManufacturerApi.middleware,
      importInvoiceSvbApi.middleware,
      invoiceotherdetailsApi.middleware,
      ImportAdditionalInfoApi.middleware,
      ImportConstituentsApi.middleware,
      ImportControlApi.middleware,
      ImportProductionApi.middleware,
      ProductFTAApi.middleware,
      invoiceSupplierApi.middleware,
      importLICSchemeApi.middleware,
      importEOUDetailsApi.middleware,
      importentityApi.middleware,
      esanchitApi.middleware,
      importProductSezinfoApi.middleware,
      importProductLoadingApi.middleware,
      importcontainerApi.middleware,
      MainShipmentApi.middleware,
      importotherDetailsApi.middleware,
      importexchangeRateApi.middleware,
      importrequirementApi.middleware,
      importudfApi.middleware,
      importNotesApi.middleware,
      bondcertApi.middleware,
      reimportApi.middleware,
      importhistoryApi.middleware,
      documentsApi.middleware,
      organizationdashboardApi.middleware,
      customerorganizationApi.middleware,
      organizationGeneralApi.middleware,
      MoreAddressApi.middleware,
      DBKBankApi.middleware,   
      ShipmentPackageApi.middleware,
      exportDeclarationApi.middleware,
      shiperApi.middleware,
      bankdealerApi.middleware,
      KycAddressApi.middleware,
      KycGeneralApi.middleware,
      customerNotesApi.middleware,
      serviceApi.middleware,
      organizationContactApi.middleware,
      ConsigneeApi.middleware,
      carrierApi.middleware,
      AEODetailsApi.middleware,
      OrganizationhistoryApi.middleware,
      KycDocumentApi.middleware, 
      organizationRegApi.middleware, 
      DrawbackdetailsApi.middleware,
      CustomDetailsApi.middleware,
      organizationfilterApi.middleware,
       KycAuthorizedSlice.middleware,
      Agentslice.middleware,
      invoiceotherchargesApi.middleware,
      ActiveApi.middleware,
      ProductDEECApi.middleware,
      exportTrackingApi.middleware,
      TrackingGoodsReciptApi.middleware,
      importProductCustDutyApi.middleware,
      importProductGSTApi.middleware,
      importinvoicemiscApi.middleware, 
      exportProductEPCGApi.middleware,
      ProductDFIAApi.middleware,
      invoiceDeclarationApi.middleware,
      importProductOtherDutiesApi.middleware,
      importProductDeclaration.middleware
    ),
});